// extracted by mini-css-extract-plugin
export default {"manageTeamList":"ManageTeamList_manageTeamList__SV8e8","tableHeader":"ManageTeamList_tableHeader__-eWMr","linkStyle":"ManageTeamList_linkStyle__Ul-44"};